function pgSubscribe(form){
  var note = form.parentNode.querySelector('.news-note');
  var input = form.querySelector('input');
  if(!input.value || input.value.indexOf('@') < 1) return false;
  form.style.display = 'none';
  if(note) note.classList.add('on');
  return false;
}


function pgContact(form){
  var f = form.elements;
  var note = form.querySelector('.ct-note');
  var subject = "Papa's Grappa - " + f.topic.value;
  var body = "Name: " + f.name.value + "\nEmail: " + f.email.value + "\n\n" + f.message.value;
  window.location.href = "mailto:info@battlespirits.us?subject=" + encodeURIComponent(subject) + "&body=" + encodeURIComponent(body);
  if(note) note.classList.add('on');
  return false;
}


/* after a successful contact submit, land the user on the confirmation, not mid-page */
(function(){
  var sent = document.getElementById('ct-sent');
  if(!sent) return;
  try{
    sent.scrollIntoView({block:'center', behavior:'auto'});
    sent.focus({preventScroll:true});
  }catch(e){
    sent.scrollIntoView();
  }
})();